























































































































import { Component, Vue } from "vue-property-decorator";
import Base64 from "@/common/base64.ts";
import { wxChatShare } from "@/common/wechat.ts";
import { Tab, Tabs, Loading, List } from "vant";
import request from "@/api/index";
@Component({
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Loading.name]: Loading,
    vanList: List
  }
})
export default class Nayq extends Vue {
  columnImg: any = []; // banner
  listLoading: boolean = true;
  finished: boolean = false;
  columnId = ""; // 列表栏目id
  tabColumn: any = []; // 上面四个方块的list
  newColumn: any = []; // 下面新闻的list

  columnList = [];
  newsList = []; // 新闻列表
  mounted() {
    this.getColumnList(); // 初始化栏目
    if (ZWY_CLOUD.isOpenInApp()) {
      ZWY_CLOUD.topBarConfig({
        isShowTop: 1,
        isShowBackBtn: 1,
        isShowTitle: "南岸区疫情防控专题",
        isShowMoreBtn: "1"
      });
      ZWY_CLOUD.shareConfig({
        id: "",
        shareTitle: "南岸区疫情防控专题",
        shareDescription: "众志成城 守望相助  坚决打赢疫情歼灭战",
        sourceType: "1",
        shareImgUrl: "https://imagecdn.cqliving.com/images/icon/4.png",
        shareUrl: window.location.href,
        shareUrlQQ: window.location.href,
        shareUrlQzone: window.location.href,
        shareUrlWx: window.location.href,
        shareUrlWxMoments: window.location.href,
        shareUrlWeibo: window.location.href
      });
    } else {
      document.title = "南岸区疫情防控专题";
      wxChatShare(
        "南岸区疫情防控专题",
        "众志成城 守望相助  坚决打赢疫情歼灭战",
        window.location.href,
        "https://imagecdn.cqliving.com/images/icon/4.png"
      );
    }
  }
  tabChange(item: any, id: string) {
    if (item.columnsType == 2) {
      if (ZWY_CLOUD.isOpenInApp()) {
        ZWY_CLOUD.redirectUrl({
          id: item.id,
          sourceId: "",
          detailViewType: "98",
          sourceType: "",
          commentType: "1",
          contextType: "",
          isShowTop: "1",
          isShowBottom: "0",
          isShowMore: "1",
          url: item.columnsUrl,
          shareUrl: item.shareUrl,
          title: Base64.encode(item.name), //base 64
          synopsis: Base64.encode(item.name), //base 64
          shareImgUrl: item.imageUrl
        });
      } else {
        window.location.href = item.columnsUrl;
      }
    } else {
      this.newsList = [];
      this.finished = false;
      this.listLoading = true;
      this.columnId = id + "";
      this.getNewsList();
    }
  }
  getColumnList() {
    request.getColumns("4", "14000.14035").then(res => {
      if (res.code == 0 && res.data) {
        this.columnList = res.data.dataList;
        this.columnImg = this.columnList.slice(0, 1)[0];
        this.tabColumn = this.columnList.slice(1, 5);
        this.newColumn = this.columnList.slice(5);
        this.columnId = this.newColumn[0].id + "";
        this.getNewsList();
      }
    });
  }
  getNewsList() {
    let lastId: string = "";
    let lastSortNo: string = "";
    let lastOnlineTime: string = "";
    if (this.newsList && this.newsList.length > 0) {
      let lastItem: any = this.newsList[this.newsList.length - 1];
      lastId = String(lastItem["id"]);
      lastSortNo = String(lastItem["sortNo"]);
      lastOnlineTime = String(lastItem["onlineTime"]);
    }
    request
      .getNewsList("4", this.columnId, lastId, lastSortNo, lastOnlineTime)
      .then(res => {
        if (res.code == 0 && res.data) {
          if (res.data.news.length < 10) {
            this.finished = true;
          }
          this.listLoading = false;
          this.newsList = this.newsList.concat(res.data.news);
        }
      });
  }

  intoDetail(item: any) {
    if (ZWY_CLOUD.isOpenInApp()) {
      ZWY_CLOUD.redirectUrl({
        id: item.id,
        sourceId: item.informationId,
        detailViewType: item.detailViewType,
        sourceType: item.sourceType,
        commentType: item.commentType,
        contextType: item.contextType,
        isShowTop: "1",
        isShowBottom: "1",
        isShowMore: "1",
        url: item.url,
        shareUrl: item.shareUrl,
        title: Base64.encode(item.title), //base 64
        synopsis: Base64.encode(item.synopsis), //base 64
        shareImgUrl: item.shareImgUrl
      });
    } else {
      window.location.href = item.url;
    }
  }

  intoNewColumn(val: any) {
    if (val.columnsType == 0) {
      this.$router.push("/nayq/columnlist?columnId=" + val.id);
    } else {
      if (ZWY_CLOUD.isOpenInApp()) {
        ZWY_CLOUD.redirectUrl({
          id: val.id,
          sourceId: "",
          detailViewType: "98",
          sourceType: "",
          commentType: "1",
          contextType: "",
          isShowTop: "1",
          isShowBottom: "0",
          isShowMore: "1",
          url: val.columnsUrl,
          shareUrl: val.shareUrl,
          title: Base64.encode(val.name), //base 64
          synopsis: Base64.encode(val.name), //base 64
          shareImgUrl: val.imageUrl
        });
      } else {
        window.location.href = val.columnsUrl;
      }
    }
  }

  onListLoad() {
    if (this.newsList.length == 0) {
      return;
    }
    this.getNewsList();
  }
}
